var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('common-calendar',{ref:"calendar",attrs:{"header":{
      left: 'prev,next',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek',
    },"calendarEvents":_vm.lessonList},on:{"eventClick":_vm.eventClick,"datesRender":_vm.datesRender}}),_c('DaLessonResevationCommitDialog',{ref:"DaLessonResevationCommitDialog"}),_c('DaAllDayLessonDialog',{ref:"DaAllDayLessonDialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }